import { Button, message } from 'antd';
import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getCurrentSubmissionType, getIsPageNameNewAdmission } from '../../modules/crm/inPatient/service/crmUtils';
import { RootState } from '../../store';

const useGetPasswordExpireNotification = (): any => {
  const history = useHistory();
  const { nextAllowStatus }: any = useSelector((state: RootState): RootState => state?.admissionDetails?.claimDetails || {});

  const getNotification = (): ReactElement => {
    const isNewAdmission = getIsPageNameNewAdmission(history.location.pathname);
    const [status] = nextAllowStatus || [];
    return (
      <span>
        {
          isNewAdmission ?
            <span>
              You cannot submit a claim to this Payer as your mailbox configuration is invalid. Please reconfigure to continue.
            </span> :
            <span>
              Mailbox configuration invalid. Please reconfigure to continue submitting {getCurrentSubmissionType(status)}, to this payer.
            </span>
        }
        <div className="text-right">
          <Button data-testid="close-custom-message-notification"
            className="p-0 h-auto" danger={true} type="text" onClick={(): any => message.destroy()}>
            Close
          </Button>
        </div>
      </span>
    );
  };
  return getNotification;
};

export default useGetPasswordExpireNotification;
